<template>
  <TextInput
    :id="$attrs.id || 'rg_number'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'rg_number'"
    maxlength="15"
    :label="$attrs.label || 'RG (registro geral)'"
    :placeholder="$attrs.placeholder || ''"
    helper-message="Digite apenas números e letras que estão no seu documento de identidade"
    validations="required|rgLength|rgx:rg"
    @input="$emit('input', $event.replace(/[^0-9A-Za-z]/g, ''))"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'RGInput',
  components: {
    TextInput,
  },
  inheritAttrs: false,
  emits: ['input'],
}
</script>
<style lang="scss"></style>
